<template>
  <div>
    <b-modal
      id="modal-customer"
      ref="modal_customer"
      :title="title"
      size="xl"
      modal-class="custom-modal"
      lazy
      centered
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      @hidden="onHidden"
    >
      <b-skeleton-wrapper :loading="isBusy">
        <template #loading>
          <b-card bg-variant="light">
            <!-- Город, Источник, Комментарий -->
            <b-row class="mb-2 mt-2">
              <b-col>
                <b-skeleton width="12%" height="26%" class="mb-2"/>
                <b-skeleton type="input" height="41%"/>
              </b-col>
              <b-col>
                <b-skeleton width="20%" height="26%" class="mb-2"/>
                <b-skeleton type="input" height="41%"/>
              </b-col>
              <b-col>
                <b-skeleton width="50%" height="26%" class="mb-2"/>
                <b-skeleton type="input" height="41%"/>
              </b-col>
            </b-row>
            <!-- Тип, статус -->
            <b-row>
              <b-col cols="4">
                <b-skeleton width="8%" height="24%" class="mb-3"/>
                <b-skeleton type="input" width="100%" height="30%"/>
              </b-col>
              <b-col cols="4">
                <b-skeleton width="36%" height="23%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="39%"/>
              </b-col>
            </b-row>
            <!-- ИНН, КПП, ОГРН -->
            <b-row>
              <b-col>
                <b-skeleton width="10%" height="26%" class="mb-2"/>
                <b-skeleton type="input" height="43%"/>
              </b-col>
              <b-col>
                <b-skeleton width="10%" height="26%" class="mb-2"/>
                <b-skeleton type="input" height="43%"/>
              </b-col>
              <b-col>
                <b-skeleton width="10%" height="26%" class="mb-2"/>
                <b-skeleton type="input" height="43%"/>
              </b-col>
            </b-row>
            <!-- Заполнить данными -->
            <b-row class="mb-2">
              <b-col>
                <b-skeleton width="16%" height="100%"/>
              </b-col>
            </b-row>
            <!--Сокращённое, полное наименование заказчика -->
            <b-row>
              <b-col class="mb-0">
                <b-skeleton width="27%" height="17%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="29%" class="mb-2"/>
                <b-skeleton width="35%" height="15%"/>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-skeleton width="22%" height="17%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="29%" class="mb-2"/>
                <b-skeleton width="32%" height="15%"/>
              </b-col>
            </b-row>
            <!-- Адрес, Примечание -->
            <b-row class="mb-2">
              <b-col>
                <b-skeleton width="4%" height="26%" class="mb-2"/>
                <b-skeleton type="input" height="41%"/>
              </b-col>
            </b-row>
            <b-row class="mb-5">
              <b-col>
                <b-skeleton width="9%" height="26%" class="mb-2"/>
                <b-skeleton type="input" height="100%"/>
              </b-col>
            </b-row>
            <!-- Банковские реквизиты -->
            <b-row class="mb-1">
              <b-col>
                <b-skeleton width="15%" height="55%"/>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col>
                <b-skeleton width="6%" height="26%" class="mb-2"/>
                <b-skeleton type="input" height="41%"/>
              </b-col>
              <b-col>
                <b-skeleton width="49%" height="26%" class="mb-2"/>
                <b-skeleton type="input" height="41%"/>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col>
                <b-skeleton width="19%" height="26%" class="mb-2"/>
                <b-skeleton type="input" height="41%"/>
              </b-col>
              <b-col>
                <b-skeleton width="28%" height="26%" class="mb-2"/>
                <b-skeleton type="input" height="41%"/>
              </b-col>
            </b-row>
            <!-- Скидки -->
            <b-row class="mb-0">
              <b-col>
                <b-skeleton width="5%" height="50%" class="mb-2"/>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col>
                <b-skeleton width="12%" class="mb-2"/>
                <b-skeleton type="input" height="50%"/>
              </b-col>
            </b-row>
          </b-card>
        </template>

        <template #default>
          <b-form>
            <div class="custom-collapse-group">
              <div class="custom-collapse-header" v-b-toggle.collapse-customer-info role="button">
                <v-icon name="buttons/collapse_chevrons_down" :size="13" class="chevron-icon"/>
                <span class="custom-collapse-header-title">Данные заказчика</span>
              </div>
              <b-collapse id="collapse-customer-info" visible>
                <div class="custom-collapse-body">
                  <b-row class="align-items-end">
                    <b-col cols="8">
                      <b-form-group id="group-town" label="Город">
                        <town-select
                          :value="newItem.town_id"
                          @onSelect="onSelectTown"
                          :is-disabled="isDisabled"
                          :state="getFieldState('town_id')"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-group id="group-urflag" :label="$t('message.customers.modal.urflagInput')">
                        <b-form-radio-group
                          size="sm"
                          v-model="newItem.urflag"
                          :options="options"
                          :disabled="isDisabled"
                          name="radioOptions"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <div v-if="newItem.urflag">
                    <b-row cols="3">
                      <b-col>
                        <b-form-group id="group-inn" :label="$t('message.customers.modal.inn')">
                          <b-form-input
                            type="text"
                            size="sm"
                            :disabled="isDisabled"
                            :state="getFieldState('inn')"
                            v-model="newItem.inn"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group id="group-kpp" :label="$t('message.customers.modal.kpp')">
                          <b-form-input
                            type="text"
                            size="sm"
                            :disabled="isDisabled"
                            v-model="newItem.kpp"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group id="group-ogrn" :label="$t('message.customers.modal.ogrn')">
                          <b-form-input
                            type="text"
                            size="sm"
                            :disabled="isDisabled"
                            v-model="newItem.ogrn"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-button :disabled="isEmpty(newItem.inn) || isDisabled || isLookingUpParty" class="custom-btn-secondary mb-2 mt-1" @click="findCustomerData()">
                      <v-icon name="buttons/fill" :size="13"/>
                      Заполнить данными
                    </b-button>
                  </div>
                  <div v-else>
                  </div>

                  <b-row>
                    <b-col cols="8">
                      <b-form-group label="Полное наименование">
                        <b-form-input
                          id="input-full-name"
                          type="text"
                          size="sm"
                          :disabled="isDisabled"
                          v-model="newItem.full_name"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-group label="Сокращённое наименование">
                        <b-form-input
                          type="text"
                          size="sm"
                          :disabled="isDisabled"
                          :state="getFieldState('name')"
                          v-model="newItem.name"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col>
                      <b-form-group label="Адрес">
                        <b-form-input
                          type="text"
                          size="sm"
                          :disabled="isDisabled"
                          :placeholder="$t('message.customers.modal.addressPlaceholder')"
                          v-model="newItem.address"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row class="align-items-end">
                    <b-col cols="4">
                      <b-form-group id="group-status" label="Статус заказчика">
                        <customer-status-select
                          :value="newItem.status_id"
                          @onSelect="onSelectCustomerStatus"
                          :is-disabled="isDisabled"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group id="group-marketing-source" label='Источник'>
                        <marketing-source-select
                          :value="newItem.marketing_source_id"
                          :is-disabled="isDisabled"
                          :state="getFieldState('marketing_source_id')"
                          @onSelect="onSelectMarketingSource"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group id="group-marketing-source-comment" label="Источник комментарий">
                        <b-form-input
                          type="text"
                          size="sm"
                          :disabled="isDisabled"
                          v-model="newItem.marketing_source_comment"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-form-group id="group-description" :label="$t('message.customers.modal.descriptionInput')">
                    <b-form-textarea
                      size="sm"
                      :disabled="isDisabled"
                      :placeholder="$t('message.customers.modal.descriptionPlaceholder')"
                      v-model="newItem.description"
                      :rows="3"
                      :max-rows="6"
                    />
                  </b-form-group>
                </div>
              </b-collapse>
            </div>

            <div class="custom-collapse-group">
              <div class="custom-collapse-header" v-b-toggle.collapse-customer-bank-details role="button">
                <v-icon name="buttons/collapse_chevrons_down" :size="13" class="chevron-icon"/>
                <span class="custom-collapse-header-title">Банковские реквизиты</span>
              </div>
              <b-collapse id="collapse-customer-bank-details" visible>
                <div class="custom-collapse-body">
                  <b-row cols="2">
                    <b-col>
                      <b-form-group id="group-bik" :label="$t('message.customers.modal.bik')">
                        <b-form-input
                          size="sm"
                          autocomplete="off"
                          :disabled="isDisabled"
                          v-model="newItem.bik"
                        />
                      </b-form-group>

                      <b-form-group id="group-cor-account" :label="$t('message.customers.modal.cor_account')">
                        <b-form-input
                          size="sm"
                          autocomplete="off"
                          :disabled="isDisabled"
                          v-model="newItem.cor_account"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group id="group-bank" :label="$t('message.customers.modal.bank')">
                        <b-form-input
                          size="sm"
                          autocomplete="off"
                          :disabled="isDisabled"
                          v-model="newItem.bank"
                        />
                      </b-form-group>

                      <b-form-group id="group-checking-account" :label="$t('message.customers.modal.checking_account')">
                        <b-form-input
                          size="sm"
                          autocomplete="off"
                          :disabled="isDisabled"
                          v-model="newItem.checking_account"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="2">
                      <b-form-group label="Скидки">
                        <b-form-input
                          type="number"
                          size="sm"
                          :disabled="isDisabled"
                          v-model.number="newItem.sale"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
              </b-collapse>
            </div>

            <div class="custom-collapse-group">
              <div class="custom-collapse-header" v-b-toggle.collapse-customer-contacts role="button">
                <v-icon name="buttons/collapse_chevrons_down" :size="13" class="chevron-icon"/>
                <span class="custom-collapse-header-title">Контакты</span>
              </div>
              <b-collapse id="collapse-customer-contacts" visible>
                <div class="custom-collapse-body">
                  <p v-if="!isDisabled && newItem.contacts.length === 0" class="text-small text-danger">Добавьте хотя бы один заполненный контакт.</p>
                  <template v-if="isBusyContacts || (newItem.contacts && newItem.contacts.length > 0)">
                    <b-table
                      id="customer-contacts"
                      ref="customer_contacts"
                      class="custom-table mb-0 text-small text-center"
                      responsive
                      :busy.sync="isBusyContacts"
                      :items="newItem.contacts"
                      :fields="contactsFields"
                    >
                      <template #table-busy>
                        <tables-skeleton :fields="contactsFields" :rows="2"/>
                      </template>

                      <template #cell(phone)="row">
                        <a :href=telUrl(row.item.phone)>{{phoneString(row.item.phone)}}</a>
                      </template>

                      <template #cell(name)="row">
                        <b-form-input
                          id="input-name"
                          size="sm"
                          autocomplete="off"
                          v-model="row.item.name"
                        />
                      </template>

                      <template #cell(phone)="row">
                        <b-input-group size="sm" :prepend="phoneInputPrefix(row.item.phone)">
                          <b-form-input
                            id="input-phone"
                            type="tel"
                            size="sm"
                            autocomplete="off"
                            :placeholder="$t('message.customers.modal.phonePlaceholder')"
                            v-model="row.item.phone"
                          />
                        </b-input-group>
                      </template>

                      <template #cell(email)="row">
                        <b-form-input
                          id="input-email"
                          size="sm"
                          autocomplete="off"
                          v-model="row.item.email"
                        />
                      </template>

                      <template #cell(description)="row">
                        <b-form-input
                          id="input-description"
                          size="sm"
                          autocomplete="off"
                          v-model="row.item.description"
                        />
                      </template>

                      <template #cell(action)="row">
                        <b-button variant="link" @click="removeContact(row)" :disabled="isDisabled">
                          <v-icon name="buttons/trash" :size="16"/>
                        </b-button>
                      </template>
                    </b-table>

                    <b-link class="d-flex align-items-center text-decoration-none text-success text-small pt-3" :disabled="isDisabled" @click.stop="addContact">
                      <v-icon name="buttons/plus" :size="13" class="mr-2"/>
                      Добавить
                    </b-link>
                  </template>
                  <div v-else class="empty-state-container">
                    <v-icon name="navbar/empty_table" :size="90"/>
                    <h5>Нет добавленных контактов.</h5>
                    <p>Добавьте контакты прямо сейчас</p>
                    <b-btn class="custom-btn-primary mt-1" :disabled="isDisabled" @click.stop="addContact">
                      <v-icon name="buttons/plus" :size="12" class="mr-1"/>
                      Новый контакт
                    </b-btn>
                  </div>
                </div>
              </b-collapse>
            </div>
          </b-form>
        </template>
      </b-skeleton-wrapper>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button class="custom-btn-secondary mr-2" @click="handleCancel">
            Отменить
          </b-button>
          <b-button class="custom-btn-primary" :disabled="isDisabled || loading " @click="handleOk">
            <b-spinner v-if="loading" small/>
            Сохранить
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import partyLookup from "../../network/partyLookup";
import customers from "../../network/customers";
import catalogs from "../../network/catalogs";
  import helpers from "../../utilites/helpers";
  import TablesSkeleton from "../../utilites/commonUi/TablesSkeleton.vue";
    import TownSelect from "../Catalogs/Towns/TownSelect.vue";
    import MarketingSourceSelect from "../Catalogs/MarketingSources/MarketingSourceSelect.vue";
    import CustomerStatusSelect from "../Catalogs/CustomerStatuses/CustomerStatusSelect.vue";

export default {
  name: 'Customer',
  components: { TablesSkeleton, CustomerStatusSelect, MarketingSourceSelect, TownSelect },
  mixins: [
    partyLookup,
    customers, catalogs,
    helpers
  ],
  data() {
    return {
      title: 'Заказчик',
      newItem: this.setNewItem(),
      options: [
        { text: 'Физ лицо', value: false },
        { text: 'Юр лицо', value: true },
      ],
      contactsFields: [
        {
          key: 'name',
          label: "ФИО",
        },
        {
          key: 'phone',
          label: "Телефон",
        },
        {
          key: 'email',
          label: "Email",
        },
        {
          key: 'description',
          label: "Примечание",
        },
        {
          key: 'action',
          label: "Действия",
          tdClass: 'text-center'
        },
      ],
      deleteRow: {
        id: null,
        name: '',
      },
      isDisabled: true,
      isBusy: false,
      loading: false,
      isBusyContacts: false,
    }
  },
  methods: {
    setNewItem() {
      return {
        id: null,
        name: '',
        address: '',
        active: true,
        description: '',
        town_id: null,
        urflag: true,
        rate: 0,
        sale: 0,
        inn:'',
        kpp:'',
        ogrn:'',
        full_name:'',
        bik:'',
        bank:'',
        cor_account:'',
        checking_account:'',
        contacts: [],
        marketing_source_id: null,
        marketing_source_comment: '',
        status_id: null,
        status_name: '',
      }
    },
    async showModal(customerId, isView) {
      this.isDisabled = isView;
      this.newItem = this.setNewItem();
      this.$refs.modal_customer.show();

      if (customerId) {
        await this.getCustomer(customerId);
      }
    },
    hideModal() {
      this.$refs.modal_customer.hide();
    },
    handleOk() {
      this.handleSubmit();
    },
    handleCancel() {
      this.hideModal();
    },
    onHidden() {
      this.$emit('modal-closed');
    },
    async getCustomer(customerId) {
      this.isBusy = true;
      this.loading = true;

      const result = await this.getCustomerById(customerId);

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.isBusy = false;
        this.loading = false;
        return;
      }

      this.newItem = result.data;
      await this.getContacts(this.newItem.id);

      this.isBusy = false;
      this.loading = false;
    },
    async getContacts(customerId) {
      this.isBusyContacts = true;

      const result = await this.getCustomerContactsById(customerId);

      this.newItem.contacts = (result && result.data) ? result.data : [];
      this.isBusyContacts = false;
    },
    async handleSubmit() {
      const submitValidation = [
        { item: 'town_id', message: 'Выберите город.' },
        { item: 'marketing_source_id', message: 'Выберите источник заказчика.' },
        { item: 'name', message: 'Укажите сокращённое наименование заказчика.' },
        { item: 'inn', message: 'Укажите ИНН.', condition: this.newItem.urflag }
      ];

      for (let i = 0; i < submitValidation.length; i++) {
        const validation = submitValidation[i];

        if (validation.condition !== false && !this.newItem[validation.item]) {
          this.showSubmitError(validation.message);
          return;
        }
      }

      // Удаляем незаполненные контакты
      const contacts = (this.newItem.contacts || []).filter(contact =>
        ['name', 'phone', 'email', 'description'].some(field =>
          typeof contact[field] === 'string' && contact[field].trim().length > 0
        )
      );
      if (contacts.length === 0) {
        this.showSubmitError('Добавьте хотя бы один заполненный контакт заказчика.');
        return;
      }
      this.newItem.contacts = contacts;

      this.loading = true;

      const data = { ...this.newItem };

      data.rate = parseFloat(data.rate) || 0;
      data.sale = parseFloat(data.sale) || 0;

      const method = (data.id > 0) ? this.putCustomer : this.postCustomer;
      const result = await method(data);

      if (result.status === 422) {
        if (data.urflag) {
          this.showSubmitError("Заказчик с таким ИНН уже существует. Найдите его в базе или введите корректный ИНН.");
        } else {
          this.showSubmitError("Заказчик с таким номер телефона уже существует. Найдите его в базе или введите корректный номер телефона.");
        }
        this.loading = false;
        return;
      }

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.loading = false;
        return;
      }

      this.newItem.id = result.data.id;
      this.loading = false;
      this.$emit('refresh');
      this.hideModal();
    },
    getFieldState(field) {
      const value = this.newItem[field];

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === 'number') {
        return value > 0;
      }

      return !!value;
    },
    addContact() {
      const contact = {
        id: 0,
        name: '',
        phone: '',
        email: '',
      };
      this.newItem.contacts.push(contact);
    },
    removeContact(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      const title = "Удаление контакта";
      const message = `Вы уверены, что хотите удалить ${this.deleteRow.name === "" ? "новый контакт" : `контакт ${this.deleteRow.name}`}?`;
      this.showModalDelete(title, message, function () {
        this.newItem.contacts.splice(row.index,1);
      }.bind(this));
    },
    findCustomerData() {
      return this.fillPartyByINN('customers');
    },
    onSelectTown(town) {
      if (town) {
        this.$set(this.newItem, 'town_id', town.id);
      } else {
        this.$set(this.newItem, 'town_id', null);
      }
    },
    onSelectCustomerStatus(status) {
      if (status) {
        this.$set(this.newItem, 'status_id', status.id);
        this.$set(this.newItem, 'status_name', status.name);
      } else {
        this.$set(this.newItem, 'status_id', null);
        this.$set(this.newItem, 'status_name', '');
      }
    },
    onSelectMarketingSource(source) {
      if (source) {
        this.$set(this.newItem, 'marketing_source_id', source.id);
      } else {
        this.$set(this.newItem, 'marketing_source_id', null);
      }
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Customers/Customer.vue